import { render, staticRenderFns } from "./HelpModal.vue?vue&type=template&id=37ff29d8"
import script from "./HelpModal.vue?vue&type=script&lang=ts"
export * from "./HelpModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports